import { Navigate } from 'react-router-dom'
import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import EventControlRoute from '../pages/command/ControlRoom/ControlPage/ControlPage'
import EventControlDashboard from '../pages/command/ControlRoom/Dashboard/Dashboard'
import DecisionLogs from '../pages/command/DecisionLogs/DecisionLogs'
import TacticalLog from '../pages/command/TacticalLog/TacticalLog'
import TreatmentCentre, {
  TreatmentWorkstationRoute,
} from '../pages/command/TreatmentCentres/TreatmentCentre'
import TreatmentLocations from '../pages/command/TreatmentCentres/TreatmentLocations'

export default [
  {
    path: '/commandcontrol/tacticallog',
    element: (
      <SubscriptionGate
        requiredTier={2}
        benefits={[
          'Clear record of decisions made by commanders',
          'Track actions to be completed',
          'Demonstrate safe & effective learning',
        ]}
        featureName="Tactical Logs"
      >
        <TacticalLog />
      </SubscriptionGate>
    ),
    title: 'Tactical Log'
  },
  //   {
  //     path: '/commandcontrol/decisionlogs',
  //     element: (
  //       <SubscriptionGate
  //         requiredTier={2}
  //         benefits={[
  //           'Clear record of decisions made by commanders',
  //           'Track actions to be completed',
  //           'Demonstrate safe & effective learning',
  //         ]}
  //         featureName="Decision Logs"
  //       >
  //         <DecisionLogs />
  //       </SubscriptionGate>
  //     ),
  //   },
  {
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="Command & Control"
        benefits={[
          'Live operational oversight across incidents and deployments',
          'Faster incident escalation and response management',
          'Centralised incident logging and communications',
        ]}
      />
    ),
    children: [
      {
        path: '/commandcontrol/controlroom',
        element: <EventControlDashboard />,
        title: 'Event Control'
      },
      {
        path: '/commandcontrol/controlroom/:controlRoomID',
        element: <EventControlRoute />,
      },
      {
        path: '/commandcontrol/treatmentlocations',
        element: <TreatmentLocations />,
        title: 'Treatment Locations'
      },
      {
        // The workstation directory has been merged into Treatment Locations;
        // keep old bookmarks working.
        path: '/commandcontrol/treatmentworkstations',
        element: <Navigate to="/commandcontrol/treatmentlocations" replace />,
      },
    ],
  },
  {
    element: (
      <SubscriptionGate requiredTier={2} featureName="Treatment Centres" />
    ),
    children: [
      {
        path: '/treatmentlocations/:treatmentLocationID',
        element: <TreatmentCentre />,
      },
      {
        path: '/treatmentworkstations/:treatmentLocationID',
        element: <TreatmentWorkstationRoute />,
      },
    ],
  },
]
